import script from "./PineappleNotificationsPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./PineappleNotificationsPage.vue?vue&type=script&lang=ts&setup=true"

import "./PineappleNotificationsPage.vue?vue&type=style&index=0&id=7273e4af&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7273e4af"]])

export default __exports__